import React from 'react'
import {
  CheckoutItemContainer,
  ImageContainer,
  BaseSpan,
  Quantity,
  Arrow,
  Value,
  RemoveButton,
} from './checkout-item.styles';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import {clearItemFromCart,addItemToCart,removeItemToCart} from '../../store/cart/cart.action';
import { selectCartItems } from '../../store/cart/cart.selector';
const CheckoutItem = ({cartItem}) => {
  
  const dispatch = useDispatch();
  const {name,imageUrl,price,quantity} =cartItem
  const cartItems = useSelector(selectCartItems)
  const clearITemHandler = () => {
    dispatch(clearItemFromCart(cartItems,cartItem))
  }
  const addItemHandler = ()=> dispatch(addItemToCart(cartItems,cartItem));
  const removeItemHandler = () => dispatch(removeItemToCart(cartItems,cartItem));
  return (
    <CheckoutItemContainer>
    <ImageContainer>
      <img src={imageUrl} alt={`${name}`} />
    </ImageContainer>
    <BaseSpan> {name} </BaseSpan>
    <Quantity>
      <Arrow onClick={removeItemHandler}>&#10094;</Arrow>
      <Value>{quantity}</Value>
      <Arrow onClick={addItemHandler}>&#10095;</Arrow>
    </Quantity>
    <BaseSpan> {price}</BaseSpan>
    <RemoveButton onClick={clearITemHandler}>&#10005;</RemoveButton>
  </CheckoutItemContainer>
  )
}

export default CheckoutItem
